var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#E2E9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.70801C9.97504 6.70801 6.70837 9.97467 6.70837 13.9997C6.70837 18.0247 9.97504 21.2913 14 21.2913C18.025 21.2913 21.2917 18.0247 21.2917 13.9997C21.2917 9.97467 18.025 6.70801 14 6.70801ZM14.7292 17.6455H13.2709V13.2705H14.7292V17.6455ZM14.7292 11.8122H13.2709V10.3538H14.7292V11.8122Z",
    fill: "#1F51E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitIcon);
export default __webpack_public_path__ + "static/media/SubmitIcon.8fa6f7a0155ec941110978b21028d3bc.svg";
export { ForwardRef as ReactComponent };